"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Component: Notification
 * ------------------------------------------------------------------------------
 * Simple component to remove a container on click and disable using cookies.
 *
 * @namespace example
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-notification="container"]',
  close: '[js-notification="close"]'
};
/**
 * Create a new notification object.
 */

var _default = function _default(config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    enableCookies: false,
    cookie: {
      expiry: 7
    }
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  /**
   * DOM node selectors.
   */

  var nodeSelectors = {
    container: document.querySelector(config.container)
  };
  /**
   * Initialise component.
   */

  function init() {
    if (!nodeSelectors.container) {
      return;
    }

    if (settings.enableCookies && isCookieSet()) {
      return;
    }

    setInitState();
    setTriggerEvents();
  }
  /**
   * Set listeners.
   */


  function setTriggerEvents() {
    (0, _utils.on)('click', nodeSelectors.container.querySelector(selectors.close), function (event) {
      return handleCloseEvent(event);
    });
  }
  /**
   * Set init state.
   */


  function setInitState() {
    nodeSelectors.container.classList.add(_cssClasses["default"].active);
  }
  /**
   * Handle close event.
   * @param {Event} event - Click event.
   */


  function handleCloseEvent(event) {
    event.preventDefault();
    nodeSelectors.container.classList.remove(_cssClasses["default"].active);
    Frame.EventBus.emit('Notification:dismissed');

    if (settings.enableCookies && isCookieDefined()) {
      _jsCookie["default"].set(settings.cookie.namespace, settings.cookie.value, {
        expires: settings.cookie.expiry
      });
    }
  }
  /**
   * Check if cookie properties are defined.
   */


  function isCookieDefined() {
    return typeof settings.cookie.namespace === 'string' && typeof settings.cookie.value === 'string';
  }
  /**
   * Cookies are set.
   */


  function isCookieSet() {
    return typeof _jsCookie["default"].get(settings.cookie.namespace) !== 'undefined';
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;